<script lang="ts">
  import { onMount } from 'svelte';
  import {
    Router,
    Route,
    createHistory,
    createMemorySource
  } from 'svelte-navigator';
  import { _ } from 'svelte-i18n';

  import { AppState, ToastQueue } from '../../etc/stores';

  import ConnectAccount from '../../pages/ConnectAccount.svelte';
  import Dashboard from '../../pages/Dashboard.svelte';
  import LoginMethod from '../../pages/LoginMethod.svelte';
  import Code from '../../pages/Verification.svelte';
  import Welcome from '../../pages/Welcome/index.svelte';
  import ConvertCoins from '../../pages/ConvertCoins.svelte';
  import Transactions from '../../pages/Transactions.svelte';
  import HowItWorks from '../../pages/HowItWorks.svelte';
  import AccountName from '../../pages/AccountName.svelte';
  import ConnectEmail from '../../pages/ConnectEmail.svelte';
  import ReferralProgram from '../../pages/Referral.svelte';
  import SoftLogin from '../../pages/SoftLogin.svelte';
  import CustomerImportWelcome from '../../pages/CustomerImportWelcome.svelte';
  import CustomerImportLoading from '../../pages/CustomerImportLoading.svelte';
  import CustomerImportRedeemStatus from '../../pages/CustomerImportRedeemStatus.svelte';
  import SocialRewards from '../../pages/SocialRewards.svelte';
  import CustomerAcquisition from '../../pages/CustomerAcquisition.svelte';
  import PaymentCodes from '../../pages/PaymentCodes.svelte';
  import CustomerAcquisitionLoading from '../../pages/CustomerAcquisitionLoading.svelte';

  const getInitialPathName = () => {
    if (
      $AppState.website.popoverRouteOnOpen &&
      $AppState.website.popoverRouteOnOpen.route
    )
      return '/loading-route';

    if ($AppState.customer?.wallet && $AppState.auth.connected)
      return '/dashboard';

    return '/';
  };

  let initialPathName = getInitialPathName();

  const memoryHistory = createHistory(createMemorySource(initialPathName));

  let authStateObserver = false;
  let auxLogout: boolean;

  const verifyCredentials = () => {
    if ($AppState.website.authFlow === 'customer-import') return;

    if ($AppState.customer?.wallet && $AppState.auth.connected) {
      memoryHistory.navigate('/dashboard');
    } else {
      memoryHistory.navigate('/');
    }
  };

  onMount(() => {
    if ($AppState.website.popoverRouteOnOpen) {
      const { route, navigationOptions } = $AppState.website.popoverRouteOnOpen;
      AppState.update(state => ({
        ...state,
        website: {
          ...state.website,
          popoverRouteOnOpen: null
        }
      }));

      memoryHistory.navigate(route, navigationOptions);
    } else {
      verifyCredentials();
    }
  });

  $: {
    if (!!$AppState.customer?.wallet !== authStateObserver) {
      verifyCredentials();
      authStateObserver = !!$AppState.customer?.wallet;
    }
  }

  $: {
    if ($AppState.auth.isLogout !== auxLogout) {
      auxLogout = $AppState.auth.isLogout;
      memoryHistory.navigate('/');
      ToastQueue.add({
        title: $_('error.title'),
        message: $_('error.unauthorized'),
        type: 'error',
        duration: 5000
      });
    }
  }
</script>

<Router history={memoryHistory}>
  <Route path="/" component={Welcome} />
  <Route path="dashboard" component={Dashboard} />
  <Route path="connect-account" component={ConnectAccount} />
  <Route path="connect-email" component={ConnectEmail} />
  <Route path="login-method" component={LoginMethod} />
  <Route path="code" component={Code} />
  <Route path="convert-coins" component={ConvertCoins} />
  <Route path="payment-codes" component={PaymentCodes} />
  <Route path="transactions" component={Transactions} />
  <Route path="how-it-works" component={HowItWorks} />
  <Route path="account-name" component={AccountName} />
  <Route path="referral-program" component={ReferralProgram} />
  <Route path="soft-login" component={SoftLogin} />
  <Route path="social-rewards" component={SocialRewards} />
  <Route path="customer-import-loading" component={CustomerImportLoading} />
  <Route path="customer-import-welcome" component={CustomerImportWelcome} />
  <Route
    path="customer-import-redeem-status"
    component={CustomerImportRedeemStatus}
  />
  <Route path="customer-acquisition" component={CustomerAcquisition} />
  <Route
    path="customer-acquisition-loading"
    component={CustomerAcquisitionLoading}
  />
</Router>
